export default __webpack_public_path__ + "static/media/example_photo.9856a3ba.jpg";